import type { IconDefinition } from '../index.tsx';

export const iconCheck: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconCheck',
  icon: [
    16,
    16,
    [],
    '',
    'M15.4144 4.41436L6.00015 13.8286L0.585938 8.41436L3.41436 5.58594L6.00015 8.17172L12.5859 1.58594L15.4144 4.41436Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
